import React, {useContext, useEffect} from "react";
import {useFormikContext} from 'formik'
import {Grid} from '@mantine/core';
import MantineSelectField from "../../../../FormikUtils/MantineSelectField";
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import MantineNumberField from "../../../../FormikUtils/MantineNumberField";
import AutomotorContext from "../../../../../../context/products/AutomotorContext/AutomotorContext";
import withMultipleContexts from "../../../../../../context/utils/withMultipleContexts";
import loadAutomotorData from "../../../../../../context/products/AutomotorContext/loadAutomotorData";
import AutomotorContextProvider from "../../../../../../context/products/AutomotorContext/AutomotorContextProvider";
import {findSelectedLabel} from "../../../../../utils/findSelectedLabel";

function VehiculoForm(props) {
    const {
        formField: {
            vehiculo: {
                marca,
                anio,
                patente,
                modelo,
                version,
                tieneGnc,
                valorGnc,
                adtValue
            }},
        vehicleDetails
    } = props;
    const {
        marcas,
        anios,
        modelos,
        versiones,
        updateModels,
        updateVersions,
        isLoadingModels,
        isLoadingVersions
    } = useContext(AutomotorContext);
    const {values, setFieldValue} = useFormikContext();

    const gnc_options = [
        {value: "1", label: "Si"},
        {value: "0", label: "No"},
    ];

    useEffect(() => {
        if (values.vehiculo.anio !== '') {
            if (typeof values.vehiculo.marca !== 'string') {
                setFieldValue(modelo.name, '', false);
                setFieldValue(version.name, '', false);
            }
            updateModels(values.vehiculo.marca, values.vehiculo.anio, true);
        }
    }, [values.vehiculo.anio, values.vehiculo.marca]);

    useEffect(() => {
        if (values.vehiculo.modelo !== '') {
            setFieldValue(version.name, '', false);
            updateVersions(values.vehiculo.marca, values.vehiculo.anio, values.vehiculo.modelo, true);
        }
    }, [values.vehiculo.modelo]);

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={3}>
                    <MantineSelectField
                        name={marca.name}
                        label={marca.label}
                        data={marcas}
                        withAsterisk
                        searchable
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_marca: findSelectedLabel(marcas, value)
                            }
                        }}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={2}>
                    <MantineSelectField
                        name={anio.name}
                        label={anio.label}
                        data={anios}
                        searchable
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={3}>
                    <MantineSelectField
                        name={modelo.name}
                        label={modelo.label}
                        loading={isLoadingModels}
                        data={modelos}
                        clearable
                        searchable
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_modelo: findSelectedLabel(modelos, value)
                            }
                        }}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={4}>
                    <MantineSelectField
                        name={version.name}
                        label={version.label}
                        loading={isLoadingVersions}
                        data={versiones}
                        clearable
                        searchable
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_version: findSelectedLabel(versiones, value)
                            }
                        }}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={patente.name}
                        label={patente.label}
                        styles={{input: {textTransform: "uppercase"}}}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineNumberField
                        name={adtValue.name}
                        label={adtValue.label}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={tieneGnc.name}
                        label={tieneGnc.label}
                        data={gnc_options}
                    />
                </Grid.Col>
                {values.vehiculo.tieneGnc === '1' && (
                    <>
                        <Grid.Col xs={12} sm={6}>
                            <MantineNumberField
                                name={valorGnc.name}
                                label={valorGnc.label}
                                data={anios}
                                min={450000}
                                max={3000000}
                            />
                        </Grid.Col>
                    </>
                )}

                <Grid.Col xs={12} sm={6}/>
            </Grid>
        </React.Fragment>
    );
}

export default withMultipleContexts(VehiculoForm, [
    {
        loadDataFunctions: [loadAutomotorData],
        ContextProvider: AutomotorContextProvider,
        dataKey: 'automotorData',
        storageKey: 'automotorData',
    }
])